import { CustomQuestion } from '../events/interfaces'

export enum DistributionType {
  INSTANT = 'INSTANT',
  DEADLINE = 'DEADLINE',
}

export enum ExternalPayment {
  YES = '1_YES',
  NO = '2_NO',
}

export enum ExternalRegistration {
  YES = '1_YES',
  NO = '2_NO',
}

export type PaymentConfiguration = {
  enabled: boolean
  methods?: string[]
  notes_html?: string
}

export enum OnlinePaymentTypes {
  paypal = 'paypal',
  payone = 'payone',
  epay21 = 'epay21',
  pmpayment = 'pmpayment',
  epaybl = 'epaybl',
}

export const onlinePaymentTypeNames: Record<OnlinePaymentTypes, string> = {
  paypal: 'PayPal',
  payone: 'BS PAYONE',
  epay21: 'epay21',
  pmpayment: 'pmPayment',
  epaybl: 'ePayBL',
}

export type OnlinePaymentConfiguration = PaymentConfiguration &
  {
    [key in OnlinePaymentTypes]: PaymentConfiguration
  }

export type PaymentConfigurations = {
  smallprint: string
  enabled: boolean
  cash: PaymentConfiguration
  transfer: PaymentConfiguration
  debit: PaymentConfiguration
  online: OnlinePaymentConfiguration
  invoice: PaymentConfiguration
  custom: PaymentConfiguration
}

export enum AccessKeyModeChoices {
  ACCESS_KEY_REQUIRED = 'req',
  ACCESS_KEY_OFF = 'off',
  ACCESS_KEY_OPTIONAL = 'opt',
}

export enum BookingVisibility {
  DETAILED = 'detailed',
  BARS_ONLY = 'bars',
  BARS_COLOR_ONLY = 'bars_color_only',
  NEVER = 'never',
}

export enum BookingVisibilityCodes {
  ALL = 'all',
  DETAILED = 'detailed',
  BARS_ONLY = 'bars',
  BARS_COLOR_ONLY = 'bars_color_only',
  NEVER = 'never',
}

export enum DiscountCodeModes {
  DISCOUNTCODE_OFF = 'off',
  DISCOUNTCODE_PROGRAM = 'program',
  DISCOUNTCODE_EVENT = 'event',
}

export type IProgram = {
  name: string
  id: number
  events: string
  distribution_type: DistributionType
  start_registration_date: Date
  last_registration_date: Date
  has_external_payment: ExternalPayment
  has_external_registration: ExternalRegistration
  is_group_registration_enabled: boolean
  is_group_strict: boolean
  requires_family_data: boolean
  max_num_adults: number
  family_data_children_max_age: number
  max_registrations_per_participant: number
  payment_configuration: PaymentConfigurations
  available_tags: string[]
  basic_fee: number
  participant_questions: CustomQuestion[]
  access_key_mode: AccessKeyModeChoices
  loading_via_access_keys_possible: boolean
  ask_for_photo_permission: boolean
  ask_for_photo_text_html: string
  agreement_html: string
  conditions_html: string
  booking_visibility: BookingVisibility
  booking_visibility_codes: BookingVisibilityCodes
  hide_past_events: boolean
  hide_booking_after_program_end: boolean
  hide_event_occupation: boolean
  age_check_tolerance: number
  debit_organizer_names: string[]
  debit_creditor_name: string
  restrict_zip_codes: boolean
  restricted_zip_codes: string[]
  resolve_time_conflict_after_payment: boolean
  hidden_optional_fields: string
  ad_left_img: string
  ad_top_img: string
  ad_right_img: string
  ad_left_link: string
  ad_top_link: string
  ad_right_link: string
  use_workflow: boolean
  is_participant_registration_allowed: boolean
  is_organizer_registration_date_change_allowed: boolean
  enable_preview_images: boolean
  discountcode_mode: DiscountCodeModes
  count_all_occupations: boolean
  gender_selection_needed: boolean
}
